<template>
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="512.000000pt" height="512.000000pt" viewBox="0 0 512.000000 512.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
fill="currentColor" stroke="none">
<path d="M1175 4464 c-202 -43 -381 -188 -471 -379 -66 -144 -64 -85 -64
-1525 0 -1440 -2 -1381 64 -1525 69 -147 174 -253 321 -325 152 -74 81 -71
1570 -68 l1330 3 80 27 c216 74 369 227 443 443 l27 80 3 1330 c3 1475 5 1415
-62 1560 -91 195 -271 337 -478 379 -113 23 -2654 23 -2763 0z m2744 -159
c187 -44 342 -199 386 -386 11 -48 15 -126 15 -311 l0 -248 -163 0 -163 0 -13
49 c-36 140 -158 268 -307 322 -83 30 -225 30 -308 0 -149 -54 -271 -182 -307
-322 l-13 -49 -326 0 -326 0 -13 49 c-36 140 -158 268 -307 322 -83 30 -225
30 -308 0 -149 -54 -271 -182 -307 -322 l-13 -49 -323 0 -323 0 0 248 c0 185
4 263 15 311 44 184 199 341 381 385 91 22 2630 23 2723 1z m-1864 -736 c237
-112 246 -441 15 -568 -60 -33 -71 -36 -150 -36 -78 0 -91 3 -148 34 -249 135
-220 488 48 585 63 23 170 16 235 -15z m1600 0 c237 -112 246 -441 15 -568
-60 -33 -71 -36 -150 -36 -78 0 -91 3 -148 34 -249 135 -220 488 48 585 63 23
170 16 235 -15z m-2196 -418 c36 -140 159 -269 307 -322 83 -30 225 -30 308 0
149 53 273 184 306 321 l12 50 327 0 327 0 13 -49 c36 -140 159 -269 307 -322
83 -30 225 -30 308 0 149 53 273 184 306 321 l12 50 164 0 164 0 0 -640 0
-640 -483 0 -483 0 -13 49 c-36 140 -158 268 -307 322 -83 30 -225 30 -308 0
-149 -54 -271 -182 -307 -322 l-13 -49 -166 0 -166 0 -13 49 c-36 140 -158
268 -307 322 -83 30 -225 30 -308 0 -149 -54 -271 -182 -307 -322 l-13 -49
-163 0 -163 0 0 640 0 640 323 0 323 0 13 -49z m272 -1020 c69 -33 112 -74
150 -143 31 -57 34 -70 34 -148 0 -79 -3 -90 -36 -150 -154 -280 -571 -191
-597 127 -11 144 76 275 218 327 60 22 170 15 231 -13z m1280 0 c69 -33 112
-74 150 -143 31 -57 34 -70 34 -148 0 -79 -3 -90 -36 -150 -154 -280 -571
-191 -597 127 -11 144 76 275 218 327 60 22 170 15 231 -13z m-1872 -420 c25
-98 110 -212 202 -271 80 -52 153 -72 259 -72 106 0 179 20 259 72 93 59 178
174 201 270 l12 50 167 0 167 0 13 -49 c36 -140 159 -269 307 -322 83 -30 225
-30 308 0 149 53 273 184 306 321 l12 50 484 0 484 0 0 -247 c0 -186 -4 -264
-15 -312 -44 -187 -199 -342 -386 -386 -96 -22 -2622 -22 -2718 0 -187 44
-342 199 -386 386 -11 48 -15 126 -15 312 l0 247 163 0 163 0 13 -49z"/>
</g>
</svg>
</template>